import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  SCORE_GRADE_CATEGORIES,
  SCORE_GRADE_LEVELS,
  SCORE_HELP_TOPICS,
  ScoreStatusInput,
} from './learning-score-status-widget.option';

@Component({
  selector: 'app-learning-score-status-widget',
  templateUrl: './learning-score-status-widget.component.html',
  styleUrls: ['./learning-score-status-widget.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningScoreStatusWidgetComponent {
  @Input() public scoreStatus: ScoreStatusInput;
  public readonly gradeCategories = SCORE_GRADE_CATEGORIES;
  public readonly gradeLevels = SCORE_GRADE_LEVELS;
  public readonly helpTopics = SCORE_HELP_TOPICS;

  public trackByValue(index: number, value: string | number): string | number {
    return value;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/learning-tree/learning-score-status-widget.component.ts